import { fetchApi } from '@/config/axiosSetting';
import {
  GetSignatureQueryParamsResponseType,
  GetSignatureQueryParamsType,
} from '@/modules/adjusterReportModules/queries/getSignature/getSignatureQuery.type';

export const getPropertyDamagedSignatureFunction = (
  params: GetSignatureQueryParamsType,
): Promise<GetSignatureQueryParamsResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/images/signature/`,
    { params: { damaged_id: params.damagedId } },
  );
};
